import Joi from 'joi';

const generalRule = Joi.number().required();

export const sourceSchema = Joi.object().pattern(/.*/, generalRule);